import { render, staticRenderFns } from "./addProgramActivityComponent.vue?vue&type=template&id=b6058f48&scoped=true"
import script from "./addProgramActivityComponent.vue?vue&type=script&lang=js"
export * from "./addProgramActivityComponent.vue?vue&type=script&lang=js"
import style0 from "./addProgramActivityComponent.vue?vue&type=style&index=0&id=b6058f48&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6058f48",
  null
  
)

export default component.exports